<template>
  <button
    v-bind:class="{'scale-box':scale}"
    ondragstart="return false;"
    @click="handleClick"
    @touchstart="handleScale"
    @mousedown="handleScale"
    @mouseup="handleRestore"
    @mouseout="handleRestore"
    @touchcancel="handleRestore"
    @touchend="handleRestore"
  >
    <img
      :src="gamePic"
      ondragstart="return false;"
      class="img"
      v-bind:style="{'height':h,'width':w,'marginLeft':left}"
    />
  </button>
</template>
<script>
export default {
  name: "scaleBox",
  props: {
    gamePic: {
      type: String,
      required: true
    },
    w: {
      type: String,
      required: true
    },
    h: {
      type: String,
      required: true
    },
    left: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      scale: false
    };
  },
  methods: {
    handleClick() {
      this.$emit("click");
    },
    handleScale() {
      this.scale = true;
    },
    handleRestore() {
      this.scale = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.scale-box {
  -webkit-transform: scale(0.95);
  transform: scale(0.95);
}
.img {
  width: 100%;
  float: left;
  transform: rotate(90deg);
}
</style>